export const PHONE_DISPLAY = "614-202-7086";
export const PHONE_HREF = "tel:6142027086";
export const WEBSITE = "www.surgevity.solutions";
export const SUPPORT_EMAIL = "info@surgevity.solutions";

export const COVERAGE_NOTE =
  "Coverage depends on eligibility and a clinical assessment. We'll help you understand your options.";
export const MEDICAID_TEXT =
  "Peer Support and CDCA Counseling may be covered by Ohio Medicaid for eligible individuals. Coverage begins with an assessment and an individualized treatment plan.";
export const RATES_PLACEHOLDER = "[Rates available upon request]";
export const FORM_PRIVACY_NOTE =
  "Don't include your Medicaid ID or health details in this form. We'll collect that securely later.";

export const CLIENT_ADVOCATE = {
  name: "Kayona Ward (CEO)",
  phone: "614-202-7086",
  email: "info@surgevity.solutions",
};

export const NPP_EFFECTIVE = "October 18, 2026";
export const PRIVACY_OFFICER = { name: "Kayona Ward (CEO)", email: "info@surgevity.solutions", phone: "614-202-7086" };

export const GFE_TEXT =
  "Good Faith Estimate: If you're paying on your own (not using Medicaid), you have the right to a Good Faith Estimate — a written estimate of expected charges — before a scheduled service. Ask us any time, and we'll provide one in plain language.";

export const MEDICAID_AGREEMENT_NOTE =
  "Ohio Medicaid members: we can only charge you for Peer Support or CDCA Counseling if you signed a written agreement with us before the service. Your Medicaid coverage can't be billed privately without your signed agreement.";

export const LANG_PHONE = "614-202-7086";
export const LANGUAGE_LINES = [
  ["English", "Free language assistance services are available to you. Call", "."],
  ["Spanish / Español", "Se ofrecen servicios de asistencia lingüística gratuita. Llame al", "."],
  ["Somali / Soomaali", "Adeegyada caawimaad luqadda oo bilaash ah ayaa la heli karaa. Wac", "."],
  ["Chinese / 中文", "我们提供免费的语言协助服务。请致电", "。"],
  ["Arabic / العربية", "تتوفر خدمات مساعدة لغوية مجانية. اتصل بـ", "."],
  ["French / Français", "Des services d'aide linguistique gratuits sont disponibles. Appelez le", "."],
  ["Russian / Русский", "Бесплатная языковая помощь доступна. Звоните", "."],
  ["Nepali / नेपाली", "निःशुल्क भाषा सहायता सेवाहरू उपलब्ध छन्। कल गर्नुहोस्", "।"],
  ["Vietnamese / Tiếng Việt", "Các dịch vụ hỗ trợ ngôn ngữ miễn phí có sẵn. Gọi", "."],
  ["Portuguese / Português", "Serviços de assistência linguística gratuita estão disponíveis. Ligue para", "."],
  ["Haitian Creole / Kreyòl Ayisyen", "Sèvis èd lang gratis disponib. Rele", "."],
  ["Ukrainian / Українська", "Безкоштовна мовна допомога доступна. Телефонуйте", "."],
  ["Swahili / Kiswahili", "Huduma za msaada wa lugha bila malipo zinapatikana. Piga simu", "."],
  ["Korean / 한국어", "무료 언어 지원 서비스를 이용하실 수 있습니다.", "로 전화하세요."],
  ["German / Deutsch", "Kostenlose Sprachhilfe ist verfügbar. Rufen Sie", " an."],
  ["Gujarati / ગુજરાતી", "મફત ભાષા સહાય સેવાઓ ઉપલબ્ધ છે. કૉલ કરો", "."],
];
export const FOOTER_STATUS =
  "Surgevity Solutions is a Behavioral Health company. Services are provided by certified and credentialed staff under appropriate supervision.";

export const SERVICES = [
  {
    slug: "peer-support",
    num: "01",
    name: "Peer Support",
    short: "Walk alongside someone who has been there.",
    description:
      "Delivered by Ohio Certified Peer Supporters, individual or group, in-person or by telehealth, tied to your personal recovery goals.",
    points: ["Ohio Certified Peer Supporters", "Individual or group", "In-person or by telehealth", "Tied to your personal recovery goals"],
    pay: ["Ohio Medicaid (eligible individuals)", "Private pay"],
    image: "/images/group.jpg",
  },
  {
    slug: "cdca-counseling",
    num: "02",
    name: "CDCA Counseling",
    short: "Substance use support with clinical oversight.",
    description:
      "Substance use services delivered by a Chemical Dependency Counselor Assistant under clinical supervision.",
    points: ["Substance use services", "Chemical Dependency Counselor Assistant", "Under clinical supervision", "Built around an individualized plan"],
    pay: ["Ohio Medicaid (eligible individuals)", "Private pay"],
    image: "/images/cdca-flower.webp",
  },
  {
    slug: "life-coaching",
    num: "03",
    name: "Life Coaching",
    short: "Direction, accountability and your next chapter.",
    description:
      "Goal-focused coaching to help you get clear on what you want next and take steady, practical steps toward it.",
    points: ["One-on-one sessions", "Goal setting and accountability", "Practical next steps", "Private pay only"],
    pay: ["Private pay only"],
    privateOnly: true,
    image: "/images/retreat.jpg",
  },
];

export const FAQS = [
  {
    q: "Do you accept Medicaid?",
    a: `${MEDICAID_TEXT} ${COVERAGE_NOTE}`,
  },
  {
    q: "What if I don't have Medicaid?",
    a: `Private pay is available for all three services: Peer Support, CDCA Counseling and Life Coaching. ${RATES_PLACEHOLDER} Reach out and we'll walk you through your options.`,
  },
  {
    q: "Is Life Coaching covered?",
    a: `No. Life Coaching is private pay only. It is not covered by Ohio Medicaid. ${RATES_PLACEHOLDER}`,
  },
  {
    q: "Do I need an assessment first?",
    a: `For Medicaid-covered services, yes. Coverage for Peer Support and CDCA Counseling begins with an assessment and an individualized treatment plan, so your care is tied to your personal recovery goals. ${COVERAGE_NOTE}`,
  },
  {
    q: "Can I do sessions by telehealth?",
    a: "Yes. Peer Support can be delivered in-person or by telehealth, individually or in a group. Ask us about telehealth for other services when you reach out.",
  },
];

export const PAYMENT_OPTIONS = ["Ohio Medicaid", "Private pay", "Not sure yet"];
export const SERVICE_OPTIONS = ["Peer Support", "CDCA Counseling", "Life Coaching", "Not sure yet"];
